<template>
  <div>
    <a-form-model ref="formVariant" :model="form">
      <a-row :gutter="16" class="mb-2">
        <a-col :span="6" style="font-weight: 500;">
          {{ $t('product.variant_name') }}
        </a-col>
        <a-col :span="18" style="font-weight: 500;">
          {{ $t('product.variant_list') }}
        </a-col>
      </a-row>
      <a-row v-for="(variant, index) in form.variants" :key="index" :gutter="16">
        <a-col :span="6">
          <a-form-model-item :prop="'variants.' + index + '.name'" :rules="{ validator: validateName, trigger: 'blur' }">
            <a-input
              v-model="variant.name"
              size="large"
              :max-length="20"
              :disabled="isLoading"
              @blur="onBlurName(index, $event)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="form.variants.length > 1 ? 17 : 18">
          <a-form-model-item :prop="'variants.' + index + '.value'" :rules="{ required: true, message: $t('product.variant_list_required'), trigger: 'change' }">
            <a-select
              v-model="variant.value"
              :placeholder="`${$t('product.type_variant_option')} ${variant.name ? variant.name : `${$t('product.variant_label')} ${index + 1}`}`"
              mode="tags"
              size="large"
              class="select-variant"
              :disabled="isLoading"
              @change="updateVariants(index)"
            />
          </a-form-model-item>
        </a-col>
        <a-col v-if="form.variants.length > 1" :span="1" style="padding: 0">
          <a-button
            type="link"
            icon="delete"
            size="large"
            :disabled="isLoading"
            @click="onConfirmRemoveVariant(index)"
          />
        </a-col>
      </a-row>
      <a-button
        type="primary"
        icon="plus"
        ghost
        class="mt-3 mb-2"
        :disabled="isLoading"
        @click="addVariant"
      >
        {{ $t('product.add_variant') }}
      </a-button>
    </a-form-model>

    <hr v-if="catalogs.items.length" />

    <div v-if="catalogs.items.length" class="variant-header mt-4">
      <a-row>
        <a-col :span="15" style="width: 62%">
          {{ $t('product.variant_label') }}
        </a-col>
        <a-col :span="6">
          SKU
        </a-col>
        <a-col :span="3">
          Status
        </a-col>
      </a-row>
    </div>
    
    <DetailCatalogMultiVariant
      v-for="(item, index) in catalogs.items"
      :key="index"
      v-model="catalogs.items[index]"
      :loading="isLoading"
      :item-id="index"
      :images="images"
      :currency="currency"
      :uom="uom"
      :validate-sku="validateSku"
      @checksku="e => $emit('checksku', e)"
      @addUom="$emit('addUom')"
      @changeUom="e => $emit('changeUom', e)"
      @upload="e => $emit('upload', e)"
      @validate="e => $emit('validate', e)"
    />
  </div>
</template>

<script>
import DetailCatalogMultiVariant from './DetailCatalogMultiVariant.vue'

export default {
  name: 'MultiVariant',
  components: {
    DetailCatalogMultiVariant,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => [],
    },
    defaultItem: {
      type: Object,
      default: () => {},
    },
    currency: {
      type: String,
      default: 'IDR',
    },
    currentUom: {
      type: String,
      default: 'PCS',
    },
    uom: {
      type: Array,
      default: () => [],
    },
    validateSku: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        variants: this.value.options.length
          ? this.value.options.map(option => ({
              name: option,
              value: this.value.attributes[option] || [],
            }))
          : [{ name: '', value: [] }],
      },
    }
  },
  computed: {
    catalogs: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    uomCurrent() {
      return this.currentUom
    },
  },
  methods: {
    validateName(rule, value, callback) {
      if (value.trim() === '') {
        callback(new Error(this.$t('product.variant_name_required')))
      } else {
        let totalName = 0
        this.form.variants.forEach(variant => {
          if (variant.name === value) totalName++
        })

        if (totalName > 1) {
          callback(new Error(this.$t('product.variant_name_duplicate')))
        } else {
          callback()
        }
      }
    },
    addVariant() {
      this.form.variants.push({ name: '', value: [] })
    },
    onConfirmRemoveVariant(index) {
      if (!this.form.variants[index].name && !this.form.variants[index].value.length) {
        this.form.variants.splice(index, 1)
      } else {
        this.$modal.confirm({
          icon: false,
          content: this.$t('product.variant_remove_confirm'),
          onOk: () => this.removeVariant(index),
        })
      }
    },
    removeVariant(index) {
      this.form.variants.splice(index, 1)
      this.updateVariants(0)
    },
    onBlurName(index, event) {
      if ((event.target.value && !this.form.variants[index].value.length) ||
        (event.target.value && this.form.variants[index].value.length && this.catalogs.attributes?.[event.target.value])) {
        return
      }

      if (!event.target.value) {
        this.form.variants[index].value = []
      }
      
      this.updateVariants(index)
    },
    updateVariants(index = '') {
      if ((index !== undefined || index !== '') && !this.form.variants[index].name) return
      
      let totalVariant = 0
      let activeKey = []
      let attributes = {}
      let options = []
      let items = [{}]
      let existingItem = []
      
      for (const item of this.form.variants) {
        if (item.name && item.value.length) {
          attributes[item.name] = item.value
          options.push(item.name)
          const tempitems = []

          for (const combination of items) {
            for (const value of item.value) {
              tempitems.push({
                ...combination,
                [item.name]: value,
              })
              activeKey.push(`${totalVariant}`)
              totalVariant++
            }
          }
          
          items = tempitems
        }
      }
      
      this.activeKey = activeKey
      this.catalogs.attributes = attributes
      this.catalogs.options = options
      this.catalogs.items = totalVariant > 0
        ? items.map(item => {
            const id = Object.values(item).join('')
            const findCatalog = this.catalogs.items.find(catalog => {
              const exist = !existingItem.includes(catalog.id) && (id.includes(catalog.id) || catalog.id.includes(id))
              if (exist) existingItem.push(catalog.id)
              return exist
            })
            const tempItem = findCatalog?.id
              ? findCatalog
              : {
                  ...this.defaultItem,
                  price: {
                    ...this.defaultItem.price,
                    uom: this.uomCurrent,
                  },
                }
            const newItem = JSON.parse(JSON.stringify(tempItem))

            return {
              ...newItem,
              id,
              title: Object.values(item).join(', '),
              option: { ...item },
            }
          })
        : []

      if (totalVariant > 0) {
        this.$emit('title')
      }
    },
  },
}
</script>

<style lang="scss">
.select-variant .ant-select-selection__rendered {
  line-height: 38px !important;
}

.variant-header {
  padding: 12px 16px;
  border: 1px solid #ccc;
  background-color: #fafafa;
}
</style>